module.exports = __webpack_public_path__ + "images/104_320.jpg";